"use client";
import {Icon} from "@iconify/react";
import {ActionIcon, Box, Button, TextInput,} from "@mantine/core";

export default function SubscribeSection({globalData}) {
    const homeMetas = globalData?.homemetas;
    const slinks = homeMetas?.social_links || [];
    const shopinfo = globalData?.shop;
    const sdata = shopinfo?.subscribe_section || {};
    const sstyle = sdata?.style || 'style1';
    const sbgcolor = sdata?.settings?.background_color || 'var(--color-secondary)';
    const stextcolor = sdata?.settings?.text_color || '#ffffff';
    const extras = sdata?.extras || [
        {icon:"mdi:envelope",title:"New Arrivals",detail:"Get updates on the latest vaping products & innovations."},
        {icon:"mdi:calendar",title:"Sent weekly",detail:"We send weekly emails, directly to your inbox."},
        {icon:"mdi:lock",title:"Safe & secure",detail:"We respect your privacy, so we’ll keep your details safe."},
    ];
    const renderStyle = () => {
        switch (sstyle) {
            case "style2":
                return (
                    <div className="flex justify-center text-center">
                        <div className="w-full lg:w-1/2 flex flex-col items-center">
                            <SubscribeForm sdata={sdata} />
                            <SocialLinks
                                links={slinks}
                                color={stextcolor}
                            />
                        </div>
                    </div>
                );

            case "style3":
                return (
                    <div className="flex flex-col gap-6">
                        <div className="w-full lg:w-1/2 mx-auto text-center">
                            <SubscribeForm sdata={sdata} />
                            <SocialLinks
                                links={slinks}
                                color={stextcolor}
                                centered
                            />
                        </div>

                        <div className="flex justify-center gap-4">
                            <Extras
                                items={extras}
                                centered
                                grid
                            />
                        </div>
                    </div>
                );

            case "style1":
            default:
                return (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
                        <Extras items={extras} />

                        <div>
                            <SubscribeForm sdata={sdata} />
                            <SocialLinks
                                links={slinks}
                                color={stextcolor}
                            />
                        </div>
                    </div>
                );
        }
    };
    return (
        <>
            <Box bg={sbgcolor} c={stextcolor} py="xl" className={`subscribe-section print:hidden ${sstyle}`}>
                <div className="max-w-7xl mx-auto px-2">
                    {renderStyle()}
                </div>
            </Box>
        </>
    )
}

function SubscribeForm({ sdata }) {
    const headline = sdata?.headline || "Subscribe to our newsletter";
    const subheadline = sdata?.subheadline;
    const promo_text = sdata?.promo_text || "Be the first to hear about new products, fantastic special offers, and vaping news.";
    const privacy_text = sdata?.privacy_text || "We value your privacy and promise to keep your details safe.";
    return (
        <div className="flex flex-col gap-2 fsform">
            <h2 className={'text-xl lg:text-2xl'}>{headline}</h2>

            {subheadline && (
                <h3 className={'text-lg lg:text-xl'}>{subheadline}</h3>
            )}

            <p>{promo_text}</p>
            <p>{privacy_text}</p>
            <div className={'grid grid-cols-12 gap-2 items-end'}>
                <div className={'col-span-12'}>
                    <TextInput size={'md'} placeholder={'Enter Email'} rightSectionWidth={120}
                        rightSection={<Button size={'sm'} ff={'heading'} fw={400} fullWidth me={'2px'}
                        >
                            Subscribe</Button>}>
                    </TextInput>
                </div>
            </div>
        </div>
    );
}

function SocialLinks({ links, color, centered = false }) {
    if (!links?.length) return null;

    return (
        <div className={`flex gap-2 items-center mt-2 flinks ${centered ? 'justify-center' : ''}`}>
            <p className="text-xl font-heading">Follow Us:</p>

            {links.map((slink, index) => (
                <ActionIcon
                    key={index}
                    color={color}
                    variant="outline"
                    radius="lg"
                    size="lg"
                    component="a"
                    href={slink.prefix + slink.value}
                    target="_blank"
                    aria-label={slink.name}
                >
                    <Icon icon={slink.icon} fontSize="1.25rem" />
                </ActionIcon>
            ))}
        </div>
    );
}

function Extras({ items, centered = false,grid= false, }) {
    return (
        <div className={`gap-2 fextras 
        ${grid ? "grid grid-cols-1 lg:grid-cols-3": "flex flex-col"} 
        ${centered ? "items-center text-center" : ""}
        `}
        >
            {items?.map((item, index) => (
                <div key={index} className={`${grid ? "flex-col items-center" : ""} flex gap-2`}>
                    <Icon icon={item.icon} fontSize={32} />

                    <div>
                        <p className="text-xl font-heading">
                            {item.title}
                        </p>

                        <p>{item.detail}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}